import { render, staticRenderFns } from "./PopupBlueprint.vue?vue&type=template&id=048f8f9e&scoped=true"
import script from "./PopupBlueprint.vue?vue&type=script&lang=js"
export * from "./PopupBlueprint.vue?vue&type=script&lang=js"
import style0 from "./PopupBlueprint.vue?vue&type=style&index=0&id=048f8f9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048f8f9e",
  null
  
)

export default component.exports